import { useEffect } from "react";

// ----------------------------------------------------------------------

export default function useMeta() {
    useEffect(() => {
        // 在head标签插入meta标签，解决在生产环境链接失效问题
        const metaTag = document.getElementsByTagName("meta");

        let isHasTag = true;

        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < metaTag.length; i++) {   // 避免重复插入meta标签

            const { httpEquiv } = metaTag[i];

            if (httpEquiv === "Cache-Control") {
                isHasTag = false;
            }
        }

        if (isHasTag) {
            const headItem = document.head;

            const oMeta = document.createElement("meta");

            oMeta.setAttribute("http-equiv", "Cache-Control");
            oMeta.content = "no-cache, no-stone, must-revalidate";

            headItem.appendChild(oMeta);
        }
    }, []);
}
